import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FullWidthBanner } from '@systemeio/components';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names';
export const MaintenanceBanner = () => {
  const $ = _c(4);
  const {
    t
  } = useLocoTranslation();
  const maintenanceWorkIsOn = useFeatureIsOn(GrowthbookFlagsEnum.MaintenanceWork);
  if (!maintenanceWorkIsOn) {
    return null;
  }
  let t0;
  if ($[0] !== t) {
    t0 = t("global.info_section_title_maintenance_work");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <FullWidthBanner contentClassName={CONTENT_CLASSNAME} variant="warning">{t0}</FullWidthBanner>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};